import { resolveCurrentWorkItemAttemptId } from './work-attempt-policy.mjs'

const validHash = value => typeof value === 'string' && /^[a-f0-9]{64}$/i.test(value)
const writableStates = ['pending', 'in_progress', 'revision_requested']

export function isTrackedWorkForm(item = {}) {
  return item.item_type === 'form_input' && Object.prototype.hasOwnProperty.call(item.input_config || {}, '_workflow_form_schema')
}

export function formSchemaContextError(message = '폼 설정을 다시 확인해 주세요.') {
  return Object.assign(new Error(message), { status: 409, code: 'WORK_FORM_SCHEMA_REQUIRED' })
}

export function buildFormSchemaInputContext(item = {}) {
  if (item.item_type !== 'form_input') return {}
  const hash = item.form_schema_sync?.effective_schema_hash
  if (!validHash(hash)) {
    if (isTrackedWorkForm(item)) throw formSchemaContextError()
    return {}
  }
  const attemptId = resolveCurrentWorkItemAttemptId(item)
  if (!attemptId) throw formSchemaContextError('현재 입력 회차를 다시 확인해 주세요.')
  return { attempt_id: attemptId, expected_form_schema_hash: hash }
}

export function buildManualFormSchemaContext(item = {}) {
  const context = buildFormSchemaInputContext(item)
  return context.expected_form_schema_hash ? {
    work_item_attempt_id: context.attempt_id,
    expected_form_schema_hash: context.expected_form_schema_hash,
  } : {}
}

export function canSyncWorkFormSchema(item = {}) {
  const sync = item.form_schema_sync
  const attemptId = resolveCurrentWorkItemAttemptId(item)
  return item.item_type === 'form_input' && Boolean(attemptId) && item.is_active !== false &&
    writableStates.includes(item.status) && (!item.work?.status || item.work.status === 'active') &&
    ['update_available', 'conflict', 'untracked'].includes(sync?.status) &&
    validHash(sync?.applied_schema_hash) && validHash(sync?.source_schema_hash) &&
    !(item.input_versions || []).some(version => String(version.attempt_id ?? version.attempt?.id ?? version.attempt) === String(attemptId))
}

export function buildFormSchemaSyncPayload(item = {}) {
  if (!canSyncWorkFormSchema(item)) throw formSchemaContextError('현재 폼 설정은 전환할 수 없습니다. 최신 상태를 다시 확인해 주세요.')
  return {
    attempt_id: resolveCurrentWorkItemAttemptId(item),
    expected_applied_schema_hash: item.form_schema_sync.applied_schema_hash,
    expected_source_schema_hash: item.form_schema_sync.source_schema_hash,
  }
}

export function isWorkFormSchemaError(error) {
  const data = error?.response?.data || error
  const code = data?.error?.code || data?.code
  return ['WORK_FORM_SCHEMA_REQUIRED', 'WORK_FORM_SCHEMA_CONFLICT'].includes(code)
}

export function workFormSchemaMessage(sync) {
  if (!sync) return ''
  if (sync.status === 'protected') return sync.requires_reentry
    ? '워크플로우 폼이 변경되었습니다. 등록된 입력은 유지됩니다. 기존 입력을 철회하거나 새 회차를 시작할 수 있는지 확인한 뒤 다시 입력해 주세요.'
    : '등록된 입력 또는 완료 이력이 있어 현재 폼 설정을 유지합니다.'
  return {
    current: '워크플로우와 같은 폼 설정을 사용하고 있습니다.',
    update_available: '추가된 선택지를 폼에 반영했습니다. 입력을 제출하면 적용이 확정됩니다.',
    conflict: '워크플로우 폼과 현재 설정이 다르거나 연결을 확인할 수 없습니다. 최신 상태를 확인해 주세요.',
    untracked: '이 폼은 워크플로우와의 자동 연동이 확인되지 않았습니다. 기존 설정을 유지합니다.',
    unavailable: '원본 워크플로우 폼의 연결 또는 접근 권한을 확인할 수 없어 기존 설정을 유지합니다.',
  }[sync.status] || '폼 설정 상태를 다시 확인해 주세요.'
}
